var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTiepThiLienKet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5714C0 12.7919 12.7919 0 28.5714 0H71.4286C87.2081 0 100 12.7919 100 28.5714V71.4286C100 87.2081 87.2081 100 71.4286 100H28.5714C12.7919 100 0 87.2081 0 71.4286V28.5714Z",
    fill: "#7B61FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6429 61.6071C66.6455 61.6071 63.9509 62.9214 62.0982 65.0032L40.7255 53.0891C40.9107 52.246 40.9107 51.375 40.7255 50.5318L62.0982 38.6177C63.9509 40.6996 66.6455 42.0139 69.6429 42.0139C75.1723 42.0139 79.6429 37.5433 79.6429 32.0139C79.6429 26.4845 75.1723 22.0139 69.6429 22.0139C64.1134 22.0139 59.6429 26.4845 59.6429 32.0139C59.6429 32.5182 59.6797 33.0143 59.7513 33.5001L38.3786 45.4142C36.526 43.3323 33.8313 42.018 30.8339 42.018C25.3045 42.018 20.8339 46.4886 20.8339 52.018C20.8339 57.5474 25.3045 62.018 30.8339 62.018C33.8313 62.018 36.526 60.7037 38.3786 58.6218L59.7513 70.5359C59.6797 71.0217 59.6429 71.5178 59.6429 72.0221C59.6429 77.5515 64.1134 82.0221 69.6429 82.0221C75.1723 82.0221 79.6429 77.5515 79.6429 72.0221C79.6429 66.4927 75.1723 62.0221 69.6429 62.0221C69.6429 61.8829 69.6429 61.7449 69.6429 61.6071Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTiepThiLienKet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TiepThiLienKet.1d279f2f.svg";
export { ForwardRef as ReactComponent };